import { Icon } from '@components/icon/Icon';
import { IconButton } from '@components/iconButton/IconButton';
import { useHtmlId } from '@shared/hooks/useHtmlId';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './DisclaimerCard.scss';

export interface DisclaimerDisplayData {
  title: string;
  description: string | null;
}

interface DisclaimerCardProps {
  disclaimer: DisclaimerDisplayData;
  onEdit?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

export const DisclaimerCard = ({
  disclaimer,
  onEdit,
  onDelete,
  disabled = false,
}: DisclaimerCardProps) => {
  const editTooltipId = useHtmlId('disclaimer-card-edit');
  const deleteTooltipId = useHtmlId('disclaimer-card-delete');
  const showActions = onEdit || onDelete;
  const title = disclaimer.title.trim() || 'Disclaimer';

  return (
    <div className={styles.disclaimerCardSaved}>
      <div className={styles.disclaimerIconWrap} aria-hidden>
        <Icon name="infoCircle" />
      </div>
      <div className={styles.disclaimerSavedContent}>
        <div className={styles.disclaimerTextBlock}>
          <span className={styles.disclaimerSavedTitle}>
            {disclaimer.title}
          </span>
          {disclaimer.description?.trim() ? (
            <p className={cx(typography.t2, styles.disclaimerSavedDescription)}>
              {disclaimer.description}
            </p>
          ) : null}
        </div>
      </div>
      {showActions && (
        <div className={styles.disclaimerSavedActions}>
          <IconButton
            ariaLabel="Edit"
            className={styles.eventModalActionIconButton}
            dataTooltipId={editTooltipId}
            disabled={disabled}
            iconName="pencil"
            onClick={() => onEdit?.()}
            tooltipContent="Edit"
          />
          <IconButton
            ariaLabel="Delete"
            className={styles.eventModalActionIconButton}
            dataTooltipId={deleteTooltipId}
            disabled={disabled}
            iconName="trash"
            onClick={() => onDelete?.()}
            tooltipContent="Delete"
          />
        </div>
      )}
    </div>
  );
};
